const Footer = ({ navItems, route, pages, setRoute }) => (

	<footer className="wi-footer">

		<div className="wi-footer-row">

			<div>
				<div className="wi-mono wi-footer-label">Menu</div>
				<div className="wi-footer-stack">
					{navItems.map((it) => (
						<button
							key={it.id}
							className={`wi-footer-link ${route === it.id ? "is-active" : ""}`}
							onClick={() => setRoute(it.id)}
						>
							{it.label}
						</button>
					))}
					{/*
					<button className="wi-footer-link" onClick={() => setRoute('home')}>Index</button>
					<button className="wi-footer-link" onClick={() => setRoute('shop')}> Editions</button>
					<button hidden className="wi-footer-link" onClick={() => setRoute('gallery')}> Archive</button>
					<button className="wi-footer-link" onClick={() => setRoute('about')}>Studio</button>
					*/}
				</div>
			</div>

			<div>
				<div className="wi-mono wi-footer-label" data-insert-html dangerouslySetInnerHTML={{__html: pages.find(p => p.slug === "footer-contact")?.subtitle}}></div>
				<div className="" data-insert-html dangerouslySetInnerHTML={{__html: pages.find(p => p.slug === "footer-contact")?.description}} ></div>
			</div>

			<div>
				<div className="wi-mono wi-footer-label" data-insert-html dangerouslySetInnerHTML={{__html: pages.find(p => p.slug === "footer-links")?.subtitle}}></div>
				<div className="wi-footer-stack" data-insert-html dangerouslySetInnerHTML={{__html: pages.find(p => p.slug === "footer-links")?.description}}></div>
			</div>

			<div className="wi-footer-colophon">
				<div className="wi-mono wi-footer-label" data-insert-html dangerouslySetInnerHTML={{__html: pages.find(p => p.slug === "footer-info")?.subtitle}}></div>
				<p data-insert-html dangerouslySetInnerHTML={{__html: pages.find(p => p.slug === "footer-info")?.description}}></p>
			</div>
			
		</div>

		<div className="wi-footer-base">
			<span className="wi-mono" data-insert-html dangerouslySetInnerHTML={{__html: pages.find(p => p.slug === "footer-left")?.description}}></span>
			<span className="wi-mono" data-insert-html dangerouslySetInnerHTML={{__html: pages.find(p => p.slug === "footer-right")?.description}}></span>
		</div>

	</footer>

);

export default Footer;